import { Store } from "./rootReducer";

/*State*/
type State = {
  approveModalOpen: boolean;
  declineModalOpen: boolean;
  guaranteeId: number | null;
};

const initialState: State = {
  approveModalOpen: false,
  declineModalOpen: false,
  guaranteeId: null,
};

/* ACTIONS */
const TOOGLE_APPROVE_MODAL = "TOOGLE_APPROVE_MODAL";
const TOOGLE_DECLINE_MODAL = "TOOGLE_DECLINE_MODAL";
const SET_GUARANTEE_ID = "SET_GUARANTEE_ID";

type Action =
  | {
      type: typeof TOOGLE_APPROVE_MODAL;
    }
  | {
      type: typeof TOOGLE_DECLINE_MODAL;
    }
  | {
      type: typeof SET_GUARANTEE_ID;
      payload: number | null;
    };

/* REDUCER */
export default function reducer(state = initialState, action: Action): State {
  switch (action.type) {
    case TOOGLE_APPROVE_MODAL:
      return {
        ...state,
        approveModalOpen: !state.approveModalOpen,
      };
    case TOOGLE_DECLINE_MODAL:
      return {
        ...state,
        declineModalOpen: !state.declineModalOpen,
      };
    case SET_GUARANTEE_ID:
      return {
        ...state,
        guaranteeId: action.payload,
      };
    default:
      return state;
  }
}

/* ACTION CREATORS */
export const setApproveModalOpen = (): Action => ({
  type: TOOGLE_APPROVE_MODAL,
});

export const setDeclineModalOpen = (): Action => ({
  type: TOOGLE_DECLINE_MODAL,
});

export const setGuaranteeId = (payload: number | null): Action => ({
  type: SET_GUARANTEE_ID,
  payload,
});

/* SELECTORS */
export const selectApproveModalOpen = (app: Store) =>
  app.modals.approveModalOpen;

export const selectDeclineModalOpen = (app: Store) =>
  app.modals.declineModalOpen;

export const selectGuaranteeId = (app: Store) => app.modals.guaranteeId;
